import React, { useState } from "react";
import { useTranslation } from "react-i18next";

// @ts-ignore
import classNames from 'classnames';
import styled from "styled-components";

const StyledLanguageSelector = styled.div`
  align-items: baseline;
  display: flex;
  flex-direction: row;
  font-size: 1rem;
  justify-content: center;

  & .language-list.closed {
    & li {
      display: none;

      &.selected {
        display: flex;
      }
    }
  }

  & .language-list {
    display: flex;
    flex: 1 0 auto;
    flex-direction: row;
    justify-content: center;
    list-style: none;

    & li {
      align-items: center;
      cursor: pointer;
      display: flex;
      font-size: 1rem;
      margin: 0;
      margin-left: 5%;
      margin-right: 5%;
      text-transform: uppercase;

      &.selected {
        display: flex;
        font-weight: bold;

        &:after {
          content: " ";
          border-bottom: 0.25rem solid transparent;
          border-left: 0.5rem solid #FFFFFF;
          border-top: 0.25rem solid transparent;
          display: block;
          height: 0;
          width: 0;
          margin-left: 20%;
        }
      }
    }
  }
`;

const onOptionClick = (language: string,
                       isSelectorOpen: boolean,
                       setIsSelectorOpen: React.Dispatch<React.SetStateAction<boolean>>,
                       setSelectedLanguage: React.Dispatch<React.SetStateAction<string>>,
                       i18n: any) => {
  return () => {
    if (!isSelectorOpen) {
      setIsSelectorOpen(true)
    } else {
      i18n.changeLanguage(language);

      setSelectedLanguage(language);
      setIsSelectorOpen(false);
    }
  }
};

interface OptionsProps {
  languages: string[],
  isSelectorOpen: boolean,
  setIsSelectorOpen: React.Dispatch<React.SetStateAction<boolean>>,
  selectedLanguage: string,
  setSelectedLanguage: React.Dispatch<React.SetStateAction<string>>,
}

const Options = (props: OptionsProps) => {
  const { i18n } = useTranslation();

  return (
    <ul className={ classNames('language-list', {closed: !props.isSelectorOpen}) }>
      <li
        onClick={
          onOptionClick(
            props.selectedLanguage,
            props.isSelectorOpen,
            props.setIsSelectorOpen,
            props.setSelectedLanguage,
            i18n
          )
        }
        className='selected'
      >
        { props.selectedLanguage }
      </li>
      { props
          .languages
          .filter(language => language !== props.selectedLanguage)
          .map(language => (
            <li
              key={ `lang-${ language }` }
              onClick={
                onOptionClick(
                  language,
                  props.isSelectorOpen,
                  props.setIsSelectorOpen,
                  props.setSelectedLanguage,
                  i18n
                )
              }
            >
              { language }
            </li>
        ))
      }
    </ul>
  );
};

const LanguageSelector = () => {
  const languages = ['es', 'en'];
  const [selectedLanguage, setSelectedLanguage] = useState(languages[0]);
  const [isSelectorOpen, setIsSelectorOpen] = useState(false);

  return (
    <StyledLanguageSelector>
      <Options
        languages={ languages }
        isSelectorOpen={ isSelectorOpen }
        setIsSelectorOpen={ setIsSelectorOpen }
        selectedLanguage={ selectedLanguage }
        setSelectedLanguage={ setSelectedLanguage }
      />
    </StyledLanguageSelector>
  );
};

export default LanguageSelector;
